import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00303 = new TileLayer({
  title: 'Máscara 20000906',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000906l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00303.setVisible(false);

const layer00302 = new TileLayer({
  title: 'Máscara 20000914',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000914l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00302.setVisible(false);

const layer00301 = new TileLayer({
  title: 'Máscara 20000922',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000922l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00301.setVisible(false);
  
const layer00300 = new TileLayer({
  title: 'Máscara 20001101',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20001101l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00300.setVisible(false);

const layer00299 = new TileLayer({
  title: 'Máscara 20010120',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010120l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00299.setVisible(false);

const layer00298 = new TileLayer({
  title: 'Máscara 20010221',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010221l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00298.setVisible(false);

const layer00297 = new TileLayer({
  title: 'Máscara 20010410',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010410l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00297.setVisible(false);
  
const layer00296 = new TileLayer({
  title: 'Máscara 20010528',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010528l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00296.setVisible(false);
  
const layer00295 = new TileLayer({
  title: 'Máscara 20010613',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010613l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00295.setVisible(false);
  
const layer00294 = new TileLayer({
  title: 'Máscara 20010629',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010629l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00294.setVisible(false);

export const grupoCapa01_21 = new LayerGroup({
  title: 'Ciclo Hidrológico 2000-2001',
  fold: 'close',
  layers: [layer00294, layer00295, layer00296, layer00297, layer00298, layer00299, layer00300, layer00301, layer00302, layer00303]
});